import React from 'react';

import clsxm from '@/lib/clsxm';

interface IProps {
  className?: string;
}

const HorizontalDivider: React.FC<IProps> = ({ className }) => {
  return <div className={clsxm('border-b border-ds-grey-400/30', className)} />;
};

export default HorizontalDivider;
